import {flow, get, toGrams, toNumber} from '@yandex-delivery/utils'

import type {NddClaimParcel, ParcelDimensions} from 'src/shared/types'

type GetFunction = (size?: ParcelDimensions) => number

const getLength: GetFunction = flow(get('length'), toNumber)

const getHeight: GetFunction = flow(get('height'), toNumber)

const getWidth: GetFunction = flow(get('width'), toNumber)

const toWeight: (weight?: number) => number = flow(toNumber, toGrams, Math.round)

const getWeightGross: GetFunction = flow(get('weight'), toWeight)

export const toPhysicalDimensions = (size?: ParcelDimensions): NddClaimParcel['physical_dims'] => {
  const height = getHeight(size)
  const length = getLength(size)
  const width = getWidth(size)

  return {
    dx: length,
    dy: height,
    dz: width,
    weight_gross: getWeightGross(size),
    predefined_volume: width * height * length * 1000,
  }
}
